{
  "version": 1,
  "asset_id": "e0552027-284e-432b-8bdc-de96f8b5c0b7",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/e0552027-284e-432b-8bdc-de96f8b5c0b7/clip-img_2370-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/e0552027-284e-432b-8bdc-de96f8b5c0b7/clip-img_2370-poster-sm.webp",
  "original_filename": "clip-img_2370-poster-sm.webp",
  "size": 18946,
  "content_type": "image/webp",
  "created_at": "2026-08-01T21:10:56Z"
}
